import {
  Box,
  Button,
  Flex,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  Spinner,
  useDisclosure,
} from '@chakra-ui/react';
import {Modal} from 'components/shared';
import {FC, PropsWithChildren, useRef, useState} from 'react';
import {colors, modalCloseButtonStyles} from 'theme';
import ImageUI from 'ui/ImageUI';
import {SpacerUI} from 'ui/SpacerUI';

type Props = {
  onImgChange: (img: string) => void;
  onFileChange?: (file: File) => void;
  isLoading?: boolean;
};
export const UploadPhoto: FC<PropsWithChildren<Props>> = ({children, onImgChange, onFileChange, isLoading = false}) => {
  const [preview, setPreview] = useState<string | null>(null);
  const {isOpen, onOpen, onClose} = useDisclosure();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const uploadFileHandler = () => {
    if (!isLoading) {
      inputRef?.current?.click();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
        onImgChange(reader.result as string);

        if (onFileChange) {
          onFileChange(file);
        }
      };
      reader.readAsDataURL(file);
    }
  };
  const handleDelete = () => {
    setPreview(null);
    onImgChange('');
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  return (
    <Flex>
      {preview && (
        <Flex style={{position: 'relative'}}>
          <Button
            minW="30px"
            h="30px"
            p={0}
            borderRadius="50%"
            bg={colors.lightGray}
            onClick={handleDelete}
            style={{position: 'absolute', right: '-8px', top: '-8px'}}
          >
            <ImageUI src="/delete-icon.svg" alt="delete" />
          </Button>

          <ImageUI
            onClick={() => onOpen()}
            cursor="pointer"
            w="50px"
            h="auto"
            borderRadius="12px"
            src={preview}
            alt="Courier Express Photo"
          />
        </Flex>
      )}
      <SpacerUI mode="horizontal" size="xll" />
      <Flex
        alignItems="center"
        justifyItems="right"
        w="fit-content"
        minW="200px"
        onClick={uploadFileHandler}
        cursor={isLoading ? 'not-allowed' : 'pointer'}
        bg={colors.lightGray}
        borderRadius="16px"
        p="12px"
        opacity={isLoading ? 0.6 : 1}
      >
        {isLoading ? <Spinner size="sm" /> : children}
        <Input
          onChange={handleFileChange}
          display="none"
          ref={inputRef}
          type="file"
          name="file"
          accept="image/png, image/jpeg, image/gif"
        />
        <SpacerUI mode="horizontal" />
        <ImageUI w="30px" h="30px" mx="auto" src="/icons/import-image.svg" alt="upload image" />
        <Box h="100%">
          {/* preview image */}
          {isOpen && preview && (
            <Modal isOpen={isOpen} onClose={onClose}>
              <ModalContent px="20px" py="25px">
                <ModalCloseButton sx={modalCloseButtonStyles} />
                <ModalBody>
                  <ImageUI borderRadius="16px" src={preview} alt="sd" />
                </ModalBody>
              </ModalContent>
            </Modal>
          )}
        </Box>
      </Flex>
    </Flex>
  );
};
